import React, {forwardRef} from "react";
import PropTypes from "prop-types";
import {ADrawer} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import useShellPositioning from "hooks/useShellPositioning";
import css from "./Drawer.module.scss";

/**
 * `Drawer` inherits all the props defined in Magna React. For more usage
 * patterns, please see:
 * @see https://magna-react.vercel.app/components/drawer#drawer-props
 */
const Drawer = forwardRef(
  (
    {
      className,
      slideIn = "right",
      isOpen,
      children,
      position = "fixed",
      onClose,
      style,
      ...rest
    },
    ref
  ) => {
    const {header} = useShellPositioning();
    const closeTestId = {"data-testid": "Drawer-Button-close"};
    return (
      <ADrawer
        {...rest}
        asModal={false}
        className={classNames(css.drawer, className)}
        slideIn={slideIn}
        isOpen={isOpen}
        position={position}
        closeBtnOnClick={onClose}
        closeBtnProps={closeTestId}
        style={{
          ...style,
          // Account for pushing drawer down due to header in Shell
          top: `${header.height}px`,
          height: `calc(100% - ${header.height}px)`
        }}
        ref={ref}>
        {children}
      </ADrawer>
    );
  }
);

const {...ADrawerProps} = ADrawer.propTypes;

Drawer.propTypes = {
  /**
   * All the props from `ADrawer`
   */
  ...ADrawerProps,

  /**
   * Function to be called when the drawer's close button is clicked.
   */
  onClose: PropTypes.func
};

export default Drawer;
